import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {ActionHandler} from "../../../../infrastructure/handlers/action-handler";
import {NewSearchWidgetSeeAllClickEvent} from "../../models/analytics/new-search-widget.see-all-click.event";

export class NewSearchWidgetSeeAllClickEventHandler extends ActionHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onSeeAllClickEvent;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super();

    this.analyticsService = analyticsService;
  }

  async action(params) {
    if(params.source){
      const clickEvent: NewSearchWidgetSeeAllClickEvent = new NewSearchWidgetSeeAllClickEvent(params.source, params.id);

      this.analyticsService.createEvent(clickEvent);
    }
  }
}
